// extracted by mini-css-extract-plugin
export var graph = "styles-module--graph--23vXT";
export var label = "styles-module--label--Z_O_i";